import { ChangeEvent } from "react"
import IScalarForm from "../interface/IScalarForm"
import Scalar from "./Scalar"
import { Button, ButtonVariant, Size } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { getID } from "src/modules/pe-landing-module/views/landing/landing-edit/utils/createMeat"

/* Protopia Ecosystem component */
export interface IOptionsProps {
   
}
const Options = (props: IScalarForm): JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<OptionsEnabled {...props} />}
        desabledForm={<OptionsDisabled {...props} />}
    />
}
export default Options

const OptionsDisabled = (props: IScalarForm): JSX.Element => {
    const value = props.value || props.default || {}
    return <div className="w-100">
            {
                Object.keys(value).map(key => {
                    return <div className="row" key={key}>
                        <div className="col-6">
                            { key }
                        </div>
                        <div className="col-6">
                            { value[ key ] }
                        </div>
                    </div>
                })
            }        
    </div>
}

const OptionsEnabled = (props: IScalarForm): JSX.Element => {
    const value = props.value || props.default || {}
    const onChange = (evt: ChangeEvent<HTMLInputElement>, type: "key" | "value", i: number) => {
        const val = evt.currentTarget.value
        let _val: any = {}
        if(type === "key") {
            Object.keys(value).forEach( (key: string, ii:number) => {
                _val[  i === ii ? val : key ] =  value[ key ] 
            })
        }
        else {
            Object.keys(value).forEach( (key: string, ii:number) => {
                _val[  key ] =  i === ii ? val : value[ key ] 
            })
        }
        
        console.log(val, type, i, _val )
        
        onAllChange( _val )
    }
    const onRmv = (key: string) => {
        const val = {...value}
        delete val[key] 
        onAllChange(val)
    }
    const onAdd = () => {
        const val = {...value}
        val[""] = ""
        onAllChange(val)
    }
    const onAllChange = (val: any) => {
        if(props.onChange) {
            props.onChange(val, props.field, "")
        }
    }
    return <div className="w-100">
            {
                Object.keys(value).map((key, i) => {
                    return <div className="row" key={key}>
                        <div className="col-5">
                            <input 
                                type="text" 
                                value={ key } 
                                className="form-control input dark" 
                                onChange={(evt: ChangeEvent<HTMLInputElement>) => onChange(evt, "key", i)} 
                                placeholder={__("key")}
                            />
                        </div>
                        <div className="col-7 d-flex">
                            <input 
                                type="text" 
                                value={  value[ key ] } 
                                className="form-control input dark flex-grow-100" 
                                onChange={(evt: ChangeEvent<HTMLInputElement>) => onChange(evt, "value", i)} 
                                placeholder={__("value")}
                            />
                            <Button size={Size.SMALL} variant={ButtonVariant.MINIMAL} icon="trash" onClick={()=> onRmv(key)}/>
                        </div>
                    </div>
                })
            }   
            <Button size={Size.SMALL} variant={ButtonVariant.MINIMAL} icon="plus" onClick={()=> onAdd()}/>     
    </div>
}